exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*\nNOTE:\nTHESE VARIABLES ARE HERE FOR THE SAKE OF COMPATIBILITY\nPLEASE USE THE ONES UNDER \"NEW NAMING\"\n*/\n\n/* NEW NAMING */\n\n/* families */\n\n/* size */\n\n/* General Indexes */\n\n/* Loading Layer */\n\n/* Component Indexes */\n\n/* Matching Pairs */\n\n/* Draw It */\n\n/* Global Transitions */\n\n.input_prompt__input--3Dlh7 {\n\tmargin: 20px 0;\n}\n\n.input_prompt__buttons--3cajP {\n\tdisplay: flex;\n\tjustify-content: space-between\n}\n\n.input_prompt__buttons_item--433Ji {\n\t\twidth: 140px;\n\t}\n", ""]);

// exports
exports.locals = {
	"input": "input_prompt__input--3Dlh7",
	"buttons": "input_prompt__buttons--3cajP",
	"buttons_item": "input_prompt__buttons_item--433Ji"
};